<template>
  <div>
    <v-row class="align-center">
      <v-col cols="12" md="6">
        <span class="titulo-header">Solicitudes</span>
      </v-col>

      <v-col cols="12" md="6" class="d-flex justify-end px-0">
        <div class="d-flex justify-end align-center" style="gap: 10px;">
          <v-menu v-if="canConsultarInspirum" offset-y class="common-botton">
            <template v-slot:activator="{ on, attrs }">
              <v-btn v-bind="attrs" v-on="on" class="common-botton" dark>
                Consultar saldo inspirum
              </v-btn>
            </template>

            <v-list>
              <v-list-item v-for="alianza in alianzasSaldo" :key="alianza.id">
                <v-btn block color="#00a7e4" text @click="getInspirumBalanceMethod(alianza.id)">
                  {{ alianza.nombre }}
                </v-btn>
              </v-list-item>
            </v-list>
          </v-menu>
          <!-- <v-autocomplete color="#00a7e4" placeholder="Consultar saldo inspirum" :items="alianzas" dense
            @change="getInspirumBalanceMethod" v-if="canConsultarInspirum" item-value="id" item-text="nombre" /> -->
          <!-- <v-btn
          class="common-botton"
          dark
          @click="getInspirumBalanceMethod()"
          v-if="canConsultarInspirum"
        >
          Consultar saldo inspirum
        </v-btn> -->
          <v-btn class="common-botton" dark @click="dialogCreate = true" v-if="canCreateSolicitudes">
            <v-icon start>mdi-plus-circle</v-icon>
            Agregar
          </v-btn>
          <v-tooltip bottom v-if="canCreateRedencionSinEmision">
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" v-on="on">
                <v-btn class="common-botton" dark :disabled="!alianzasSinEmision.length" @click="dialogRedencionSinEmisionCreate = true">
                  <v-icon left>mdi-plus-circle</v-icon>
                  Agregar redención sin emisión
                </v-btn>
              </span>
            </template>
            <span>
              {{ alianzasSinEmision.length
                  ? "Crear una redención para un cliente que aún no cuenta con emisión"
                  : "No tienes alianzas con redención sin emisión habilitada" }}
            </span>
          </v-tooltip>
        </div>
      </v-col>
    </v-row>

    <div style="padding-top: 30px;" v-if="globalConfig.showMainHubGraphs">
      <stats-solicitud></stats-solicitud>
    </div>
    <div style="padding-top: 30px;">
      <filters-solicitud-index></filters-solicitud-index>
    </div>
    <CreateBeneficioModal v-if="dialogCreate" :dialog="dialogCreate" @closeDialog="dialogCreate = false"/>
    <CreateBeneficioSinEmisionModal
      v-if="dialogRedencionSinEmisionCreate"
      :dialog="dialogRedencionSinEmisionCreate"
      :alianzas="alianzasSinEmision"
      @closeDialog="dialogRedencionSinEmisionCreate = false"
      @goToFlujoGenerico="closeRedencionSinEmisionAndOpenFlujoGenerico"
    />
  </div>
</template>

<script>
import FiltersSolicitudIndex from "./FiltersSolicitudIndex.vue";
import StatsSolicitud from "./StatsSolicitud.vue";
import CreateBeneficioSinEmisionModal from "../Create/CreateSolicitudBeneficio/CreateBeneficioSinEmisionModal.vue";
import CreateBeneficioModal from "../Create/CreateSolicitudBeneficio/CreateBeneficioModal.vue";
import { getInspirumBalanceByAlianzaId } from "@/services/inspirum/inspirum.service";
import { postReadCorreo } from "@/services/solicitudes/Solicitudes";
import { getActiveAlianzas, getAlianzasSinEmision } from "@/services/alianzas/alianzas.service";

export default {
  components: {
    FiltersSolicitudIndex,
    StatsSolicitud,
    CreateBeneficioModal,
    CreateBeneficioSinEmisionModal
  },

  data() {
    return {
      globalConfig: JSON.parse(localStorage.getItem("globalConfig")),
      rol: JSON.parse(localStorage.getItem("roles"))[0].rol,
      dialogCreate: false,
      dialogRedencionSinEmisionCreate: false,
      alianzas: [],
      alianzasSinEmision: [],
      alianzasSaldo: []
    };
  },
  mounted() {
    this.getActiveAlianzas();
    this.getAlianzasSinEmision();
  },
  methods: {
    async readEmail() {
      try {
        await postReadCorreo({});
        this.$toast.success("Correo leido con exito");
      } catch {
        this.$toast.error("Surgio un error");
      }
    },
    async getInspirumBalanceMethod(id) {
      try {
        const response = await getInspirumBalanceByAlianzaId(id);
        this.$toast.info(
          "El saldo restante es de: " + this.formatCurrency(response.balance)
        );
      } catch (error) {
        this.$toast.error(error?.response?.data?.data || error?.response?.data?.message || "Surgio un error al consultar el saldo");
      }
    },
    async getActiveAlianzas() {
      try {
        const response = await getActiveAlianzas();
        this.alianzas = response.data;
        this.alianzasSaldo = this.alianzas.filter(
          (alianza) => alianza.nombre !== "Betterware"
        );
      } catch (error) {
        this.$toast.error("Error al obtener alianzas activas:", error);
      }
    },
    async getAlianzasSinEmision() {
      try {
        this.alianzasSinEmision = (await getAlianzasSinEmision()) || [];
        console.log(this.alianzasSinEmision)
      } catch (error) {
        this.alianzasSinEmision = [];
      }
    },
    formatCurrency(amount) {
      return amount.toLocaleString("es-MX", {
        style: "currency",
        currency: "MXN",
      });
    },
    closeRedencionSinEmisionAndOpenFlujoGenerico() {
      this.dialogRedencionSinEmisionCreate = false;
      this.dialogCreate = true;
    },
  },
  computed: {
    canConsultarInspirum() {
      return this.$store.getters['roles/tienePermiso']('Solicitudes', 'Editar', 'ValidarSaldoInspirum')
    },
    canCreateSolicitudes() {
      return this.$store.getters['roles/tienePermiso']('Solicitudes', 'Crear')
    },
    canCreateRedencionSinEmision() {
      return this.$store.getters['roles/tienePermiso']('Solicitudes', 'CrearRedencionRedencionSinEmision')
    }
  },
};
</script>
